/* unplugin-vue-components disabled */import { render } from "./expanded.vue?vue&type=template&id=3b000988&scoped=true"
import script from "./expanded.vue?vue&type=script&lang=js"
export * from "./expanded.vue?vue&type=script&lang=js"

import "./expanded.vue?vue&type=style&index=0&id=3b000988&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b000988"],['__file',"src/components/ai-chat-v2/ai-assistant/expanded.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b000988"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b000988', __exports__)) {
    api.reload('3b000988', __exports__)
  }
  
  module.hot.accept("./expanded.vue?vue&type=template&id=3b000988&scoped=true", () => {
    api.rerender('3b000988', render)
  })

}


export default __exports__